@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/icon' as icon;

leichte-sprache-header {
  background-color: var.$ls-primary-color;
  color: var.$ls-text-color-dark;
  padding: 1rem 1.3rem;
  display: flex;
  align-items: center;

  h2 {
    font-size: 24px;
    margin: 0 1.3rem 0 1.3rem;
    color: currentColor;
    // At 423px h2 does not fit in one line
    @media screen and (max-width: 422px) {
      font-size: 4.7vw;
    }
  }

  button {
    background: none;
    border: none;
    color: currentColor;
    cursor: pointer;
    border-radius: 100vh;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    // Firefox on Windows displays an additional border around focused elements
    &::-moz-focus-inner {
      border: 0;
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var.$ls-focus-color;
    }
    // Double check when changing the size or position of the icons on phones and on IE
    svg {
      position: absolute; // For some reason this is needed for iOS, otherwise svg is not shown
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
    }

    &.restart-bot {
      margin-left: auto;
      svg {
        transform: translate(-50%, -50%) scale(0.8);
      }
    }

    &.close-bot {
      svg {
        transform: translate(-50%, -50%) scale(1);
      }
    }
  }
}
